export default {
    videoNotLoaded: "الفيديو غير متوفر في متصفحك",
    next: "التالي",
    previous: "السابق",
    skipAll: "تخطي الكل",
    finish: "إنهاء",
    skipTutorial: "تخطي الدليل",
    startTutorial: "بدء الدليل",
    welcome: {
        title: "مرحباً بك على متن المنصة!",
        subtitle:
            "هذا الدليل السريع يستغرق دقيقتين فقط، سيساعدك على التعرف على المنصة في خطوات بسيطة.",
        describe: "إنها عالم افتراضي حيث تلتقي الفرق وتتحدث وتتعاون بشكل طبيعي",
        describe2: " — تماماً كما في الحياة الواقعية.",
        describe3: "في هذا الدليل، ستتعلم كيفية:",
        bloc1: "التحرك في المكان",
        bloc2: "التحدث مع الآخرين",
        bloc3: "اكتشاف العناصر التفاعلية",
    },
    step1: {
        title: "استكشف عالمك",
        use: "استخدم",
        arrowkeys: " أسهم لوحة المفاتيح",
        or: "أو",
        wasd: " SchSY لتحريك الشخصية",
        aroundTheMap: "حول الخريطة. جرب ذلك الآن!",
        tip: "نصيحة:",
        describeTip:
            "اضغط باستمرار على مفتاح Shift أثناء التحرك للمشي بسرعة أكبر — مثالي إذا كنت متأخراً أو ترغب في الاستكشاف بسرعة!",
        silentZone: "أنت حالياً في منطقة صامتة — هنا، لا يمكن لأحد سماعك.",
    },
    step2: {
        title: "تحدث وتعاون",
        describe: "لبدء محادثة، اقترب من شخص ما ",
        describe2: " — سيتم تشغيل الفيديو أو الصوت تلقائياً.",
        describe3: "انقر على أيقونة القفل لجعل المحادثة خاصة.",
        describe4: "انقر على زر “مشاركة الشاشة” أثناء المحادثة لعرض شاشتك",
    },
    step3: {
        title: "اكتشف وتفاعل",
        interact: "تفاعل مع العناصر ",
        likeSign: "مثل اللافتات والشاشات والمستندات والبورتالات",
        sometimes: "— أحياناً تضيء ",
        closer: "عندما تقترب منها.",
        describe3: "اجمع الأشخاص في غرف الاجتماعات لتعزيز النقاشات العفوية والعمل الجماعي.",
        describe4: "خذ استراحة في المناطق الصامتة، المكان المثالي للتركيز والعمل دون انقطاع.",
    },
};
